import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import TopBars from '../components/TopBars';
import Hero from '../components/Hero';
import EmotionSection from '../components/EmotionSection';
import HivernageSection from '../components/HivernageSection';
import CampaignsSection from '../components/CampaignsSection';
import HowItWorks from '../components/HowItWorks';
import PaymentSection from '../components/PaymentSection';
import TrustSection from '../components/TrustSection';
import WallSection from '../components/WallSection';
import ProgramsSection from '../components/ProgramsSection';
import CountriesAndCTA from '../components/CountriesAndCTA';
import Footer from '../components/Footer';
import AuthModal from '../components/AuthModal';
import CreateCagnotteWizard from '../components/CreateCagnotteWizard';
import { useAuth } from '../context/AuthContext';

export default function Home() {
  const [wizardOpen, setWizardOpen] = useState(false);
  const [wizardType, setWizardType] = useState('Joyeuse');
  const [reloadKey, setReloadKey] = useState(0);
  const { user, authIntent, setAuthIntent } = useAuth();

  const openCreate = (type = 'Joyeuse') => { setWizardType(type); setWizardOpen(true); };

  useEffect(() => {
    if (user && authIntent) {
      if (authIntent === 'create-yako') openCreate('Yako');
      else if (authIntent === 'create-joyeuse') openCreate('Joyeuse');
      setAuthIntent(null);
    }
  }, [user, authIntent, setAuthIntent]);

  return (
    <div>
      <Header onCreate={openCreate} />
      <TopBars />
      <Hero onCreate={openCreate} />
      <EmotionSection onCreate={openCreate} />
      <HivernageSection />
      <CampaignsSection reloadKey={reloadKey} />
      <HowItWorks />
      <PaymentSection />
      <TrustSection />
      <WallSection />
      <ProgramsSection />
      <CountriesAndCTA onCreate={openCreate} />
      <Footer />

      <AuthModal />
      <CreateCagnotteWizard
        open={wizardOpen}
        onOpenChange={setWizardOpen}
        initialType={wizardType}
        onCreated={() => setReloadKey(k => k + 1)}
      />
    </div>
  );
}
